/**
 * NOTE: Web authorizes in a popup; this stub keeps `react-native-webview` off the web bundle.
 */
export const IdMeAuthorizationWebView = () => null;
